import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}

// Schritt 5: Bestaetigung
export default {
  template: html,
  emits: {
    onClose: () => true,
  },
  props: {
    cart: { type: Object, required: false, default: null },
    course: { type: Object, required: false, default: null },
    isLoggedIn: { type: Boolean, required: false, default: false },
  },
  setup(props: { isLoggedIn: boolean }, { emit }: { emit: (e: "onClose") => void }) {
    return {
      isLoggedIn: props.isLoggedIn,
      close: () => emit("onClose"),
    };
  },
};
